<template>
  <el-menu default-active="1" class="el-menu-demo" mode="horizontal" menu-trigger="hover" @select="handleSelect">
    <div class="header-hamburger" @click="$bus.$emit('toggle-sidebar')">
      <i class="el-icon-s-unfold"></i>
    </div>
    <AppHeaderMenuLogo />
    <el-submenu v-if="menu.register.length > 0" index="1">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span slot="title">{{ $t("cadastro") }}</span>
      </template>
      <el-submenu :index="name" v-for="(row, name) in subMenuList('register')" v-bind:key="name">
        <template slot="title">{{ $t(name) }}</template>
        <el-menu-item v-for="row in subMenuRegister(name)" v-bind:key="row.path" :href="row.path" :index="row.path">
          <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
          <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>{{
          $t(row.name) }}</el-menu-item>
      </el-submenu>
      <el-menu-item v-for="row in menu.register.filter(
        (data) => !data.submenu || data.submenu === ''
      )" v-bind:key="row.path" :href="row.path" :index="row.path">
        <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
        <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>
        {{ $t(row.name) }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="menu.services.length > 0" index="2">
      <template slot="title">
        <i class="el-icon-receiving"></i>
        <span slot="title">{{ $t("servicos") }}</span>
      </template>
      <el-menu-item v-for="row in menu.services" v-bind:key="row.path" :href="row.path" :index="row.path">
        <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
        <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>{{
        $t(row.name) }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="menu.search.length > 0" index="3">
      <template slot="title">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">{{ $t("consultas") }}</span>
      </template>
      <el-menu-item v-for="row in menu.search" v-bind:key="row.path" :href="row.path" :index="row.path">        <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
        <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>
{{ $t(row.name)
      }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="menu.financial.length > 0" index="4">
      <template slot="title">
        <i class="el-icon-money"></i>
        <span slot="title">{{ $t("financeiro") }}</span>
      </template>
      <el-menu-item v-for="row in menu.financial" v-bind:key="row.path" :href="row.path" :index="row.path">        <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
        <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>
{{
        $t(row.name) }}</el-menu-item>
    </el-submenu>
    <el-submenu v-if="menu.licence.length > 0" index="9">
      <template slot="title">
        <i class="el-icon-shopping-cart-2"></i>
        <span slot="title">{{ $t("pdv") }}</span>
      </template>
      <el-menu-item v-for="row in menu.licence" v-bind:key="row.path" :href="row.path" :index="row.path">        <i class="el-icon-star-on" style="color: yellow" v-if="row.favorite" @click.stop="favorite(row)"></i>
        <i v-else class="el-icon-star-off" @click.stop="favorite(row)"></i>
{{ $t(row.name)
      }}</el-menu-item>
    </el-submenu>
    <AppHeaderMenuUserInfo @logout="socket.disconnect(); logout()" />
    <AppHeaderMenuInfo @chat="chat" />
    <TruckIcon />
  </el-menu>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import io from 'socket.io-client';
import { mapActions, mapGetters } from "vuex";
import { TokenService } from '../../services/auth/storage.services';
import AppHeaderMenuInfo from "./AppHeaderMenuInfo.vue";
import AppHeaderMenuLogo from "./AppHeaderMenuLogo.vue";
import AppHeaderMenuUserInfo from "./AppHeaderMenuUserInfo.vue";
import TruckIcon from './TruckIcon';

export default {
  components: { AppHeaderMenuLogo, AppHeaderMenuInfo, AppHeaderMenuUserInfo, TruckIcon },

  data() {
    return {
      menu: {
        register: [],
        search: [],
        services: [],
        reports: [],
        financial: [],
        licence: [],
      },
      loading: false,
      percentage: 20,
      truck: false,
      department: '',
      alert: false,
      socket: null,
      username: "",
      userType: "2",
      userId: "",
      activeIndex2: "0",
      type: "1",
      total: 0,
      operator: 0,
      notifications: [],
      message: "",
    };
  },
  created() {
    const vm = this;
    vm.socket = io('/', {
      path: '/mysocket',
      transports: ['websocket'],
      rejectUnauthorized: false,
      autoConnect: false,
      query: 'token=' + TokenService.getToken(),

    });
    vm.socket.connect();
    vm.setup();
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("menu", ["save"]),
    ...mapActions("socket", ["saveSocket"]),
    favorite(row) {
      const vm = this;
      UserService.favorite(row.name)
        .then((response) => {
          vm.$bus.$emit("favoriteHandle", row);
          if (response.action === 'add') row.favorite = true;
          else row.favorite = false;
        })
        .catch((err) => {
        });
    },
    setup() {
      const vm = this;
      vm.socket.emit('chat-join');
      this.saveSocket(vm.socket);
      vm.socket.on("newMessage", (data) => {
        vm.notifications.push({
          action: 'newMessage',
          data: data,
        });
        if (this.$route.name === 'home') vm.open();
        vm.message = data;
        vm.alert = true;
        vm.total += 1;
      });
      vm.socket.on("payment-done", (data) => {
        vm.$bus.$emit("payment.done", data);
      });
      vm.socket.on("chat-operator", (data) => {
        vm.operator = data.length;
        vm.$refs.chat.received('operator', data);
      });
      vm.socket.on("chat-operator-message", (data) => {
        for (const messageData of data) {
          vm.$refs.chat.received('message', messageData);
        }
      });
      vm.socket.on("chat-operator-assign", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Atendente ${data} conectado`,
        }, true);
      })
      vm.socket.on("chat-closed", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Chat encerrado`,
        }, false);
      })
      vm.socket.on("chat-transfer", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Chat transferido outro departamento`,
        }, false);
      })
      vm.socket.on("chat-queue-ready", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Sua posição na fila é ${data}`,
        }, false);
      })
      vm.socket.on("chatMessage", (data) => {
        vm.$refs.chat.received('message', data);
      });
      vm.socket.on("chat-populate", (data) => {
        vm.operator = data.length;
        vm.$refs.chat.clear();
        for (const messageData of data) {
          vm.$refs.chat.received('message', messageData);
        }
      });
      vm.socket.on("chat-disconnected", (data) => {
        vm.$refs.chat.received('info', {
          type: 'info',
          message: `Usuário desconectado do sistema`,
        }, false);
      });
      vm.socket.open((data) => {
      });
      vm.socket.on("connect", (data) => {
        vm.socket.emit('chat-get-not-read', vm.userId)
      });
      vm.socket.on("disconnect", (data) => {
        this.socket.emit('chat-disconnect', vm.userId);
      });
      vm.socket.on("error", (data) => {
        vm.$message({
          type: "error",
          message: data,
        });
      });
    },
    goto() {
      this.alert = false;
      this.$router.replace({ name: 'notification', params: { to: 'message' } }).catch(() => { });
    },
    chat() {
      const vm = this;
      vm.socket.emit('chat-get-not-read', vm.userId)
      vm.$emit('chat');
    },
    me: function () {
      const vm = this;
      vm.loading = true;
      UserService.menu()
        .then((response) => {

          vm.menu = {
            register: [],
            search: [],
            services: [],
            reports: [],
            financial: [],
            licence: [],
          };
          console.log('response.menu', response, response.menu);
          for (const menu of response.user.menu) {
            if (menu.father) {
              vm.menu[menu.father].push(menu);
            } else if (menu.menu) {
              vm.menu[menu.menu] = true;
            }
          }
          vm.save({ menu: response });
          vm.username = response.user.name;
          vm.userId = response.user.id;
          vm.userType = response.user.type;
          if (response.user.type === '1' && response.user.department && response.user.department.chat) {
            vm.department = response.user.department.id;
          }
        })
        .catch((err) => {
        });
    },
    fetchAudit(id) {
      const vm = this;
      AuditService.findfile(id)
        .then((response) => {
          if (response.processing) {
            this.$notify({
              title: 'Arquivo de auditoria processado',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: 'Acesse a tela de de auditoria para verificar os objetos da auditoria!'
            });
            vm.$bus.$emit("audit.file.processed", id);
          } else {
            setTimeout(() => {
              vm.fetchAudit(id);
            }, 1000)
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
    },
    fetchNotifications(id) {
      const vm = this;
      UserService.notifications(id)
        .then((response) => {
          if (!response.processing) {
            this.notifications.push({ data: 'file created' });
            this.$notify({
              title: 'Arquivo gerado',
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: 'Clique no sino na parte superior ou <a href="/notifications">aqui</a> para ver o seu relatório!'
            });
          } else {
            setTimeout(() => {
              vm.fetchNotifications(id);
            }, 1000)
          }
        })
        .catch((err) => {
          vm.$message({
            type: "error",
            message: err,
          });
        });

    },
    open() {
      this.$refs.messageHighlight.open();
    },
    profile: function () {
      const vm = this;
      vm.$router.replace({ name: "profile" });
    },
    handleSelect: function (path) {
      const vm = this;
      vm.$router.push(path).catch(() => { });
    },
  },
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    subMenuList() {
      const vm = this;
      return function (item) {
        const list = {};
        for (const row of vm.menu[item]) {
          if (row.submenu) {
            list[row.submenu] = true;
          }
        }
        return list;
      };
    },
    subMenuRegister() {
      const vm = this;
      return function (name) {
        return vm.menu.register.filter(
          (data) => data.submenu && data.submenu === name
        );
      };
    },
  },
  mounted() {
    const vm = this;
    vm.me();
    vm.$bus.$on("logged", () => {
      vm.me();
    });
  },
};
</script>
<style>
.header-global {
  margin-bottom: 0;
}

/* A borda inferior é do .app-topbar (App.vue) — sem borda dupla no menu */
.app-topbar .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.header-hamburger {
  display: none;
  float: left;
  height: 60px;
  line-height: 60px;
  padding: 0 10px;
  font-size: 22px;
  color: var(--me-text-regular);
  cursor: pointer;
}

@media only screen and (max-width: 767px) {
  .header-hamburger {
    display: block;
  }
}

.item-icon {
  margin-top: 0px !important;
  margin-right: 20px;
}

@media only screen and (max-width: 1218px) {
  .el-submenu__title {
    padding: 0 2px;
  }
}

@media only screen and (max-width: 1002px) {
  .el-submenu__title span {
    display: none;
  }
}

@media only screen and (max-width: 633px) {
  .mobile {
    display: flex;
  }

  .fa-2x {
    font-size: 1.5em !important;
    padding-top: 5px !important;
  }

  .logo {
    display: none !important;
  }
}

@media only screen and (min-width: 623px) {
  .mobile {
    display: none;
  }

  .logo {
    display: flex;
  }
}

.el-popover {
  box-shadow: var(--me-shadow-lg);
}
</style>
